import { useMemo } from 'react';
import { ChoiceDrill } from './ChoiceDrill';
import { makeLangRound } from './lang';
import type { DrillProps } from './meta';

export function LangDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeLangRound(level, seed), [level, seed]);
  return (
    <ChoiceDrill
      questions={questions} seed={seed} onDone={onDone} className="lang-drill"
      info={(q) => ({ kind: q.kind, ask: q.ask, answer: q.options[q.answer] })}
      choicesClass={(q) => (q.body || q.options.some((o) => o.length > 14) ? 'one-col' : '')}
      render={(q) => (
        <div className="lang-q">
          {q.body && (
            <div className="read-box">
              {q.title && <div className="read-title">{q.title}</div>}
              {q.body.map((line, i) => <p key={i}>{line}</p>)}
            </div>
          )}
          <p className={q.body ? 'lang-ask small-ask' : 'lang-ask'}>{q.ask}</p>
        </div>
      )}
      renderChoice={(q, i) => <span className="choice-text">{q.options[i]}</span>}
    />
  );
}
